import { useSelector } from 'react-redux';
import { EnergyState } from 'store/slices/EnergySlice/types';
import { selectIsRecomputing } from 'store/slices/DsmShadingSlice/selectors';
import { PanelTitle } from '../style';
import UpdatingEstimate from './UpdatingEstimate';

interface Props {
	energy: EnergyState;
}

export default function Offset({ energy }: Props) {
	const isShadingAnalysisLoading = useSelector(selectIsRecomputing);
	const offset = Math.round((energy.deratedEnergy / energy.billEnergy) * 100);
	return <PanelTitle className='offset-title'>
		<h4>Offset</h4>
		{isShadingAnalysisLoading
			? <UpdatingEstimate />
			: <h2 className="primary-color">{`${offset}%`}</h2>
		}
	</PanelTitle>;
}
